import { render, staticRenderFns } from "./PublicGallery.vue?vue&type=template&id=11cd2860&"
import script from "./PublicGallery.vue?vue&type=script&lang=js&"
export * from "./PublicGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports